import React from 'react'

const Footer = () => {
  return (
    <div>
      <div className="footer">
        <a href="https://wa.me/9203234240630" target="_rizwan">
          <img
            src="assets/img/whatsapp.png"
            className="img-fluid whatsapp-icon"
            alt="Whatsapp Icon Image"
            srcset=""
          />
        </a>
        <div className="container">
          <div className="footer">
            <div className="row">
              <div className="col-lg-6 offset-lg-3 text-center">
                <p>Copyright © 2023 DI-BIG. All Right Reserved</p>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer
